import React from "react";
import style from "./style.less";
import { LanguageContext } from "@/data/LanguageProvider";
import { useContext, useEffect, useState } from "react";
const UserLogShow = (props) => {
  const { langText } = useContext(LanguageContext);
  const renderStatusDiv = () => {
    if (props.info.appeal_statsu) {
      if (props.info.appeal_statsu === "SUCCESS") {
        return (
          <div
            class={`${style.info_status} ${props.k === 0 ? style.first_i : ""}`}
          >
            {props.info.appeal_statsu}
          </div>
        );
      } else {
        return (
          <div
            class={`${style.info_timeout} ${props.k === 0 ? style.first_i : ""}`}
            onClick={() => {
              props.onClick && props.onClick(props.info);
            }}
          >
            {props.info.appeal_statsu === "RETURN"
              ? langText("recharge_appeal_42")
              : langText("recharge_appeal_43")}
          </div>
        );
      }

    } else {
      if (props.info.status === "TIMEOUT") {
        return (
          <div
            class={`${style.info_timeout} ${props.k === 0 ? style.first_i : ""}`}
            onClick={() => {
              props.onClick && props.onClick(props.info);
            }}
          >
            {props.info.statusText}
          </div>
        );
      } else {
        // 默认情况
        return (
          <div
            class={`${style.info_status} ${props.k === 0 ? style.first_i : ""}`}
          >
            {props.info.statusText}
          </div>
        );
      }
    }
  };


  return (
    <div
      class={`${style.info} ${props.k === 9 || props.k + 1 === props.length ? style.end_i : ""
        }`}
    >
      <div class={`${style.info_time} ${props.k === 0 ? style.first_i : ""}`}>
        {props.info.time}
      </div>
      <div class={`${style.info_amount} ${props.k === 0 ? style.first_i : ""}`}>
        {props.info.amount}
      </div>
      {
        renderStatusDiv()
      }
    </div>
  );
};

export default UserLogShow;
